import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import Swal from "sweetalert2";
import { CircularProgress } from "@mui/material";
import axiosInstance from "../../config/axiosConfig";
import Actions from "../../components/courses/Actions";

const customModalStyles = {
  content: {
    padding: "20px",
    width: "80%",
    maxWidth: "600px",
    margin: "auto",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  },
};

const emptyForm = { office: "", phone: "", order: "" };

const ContactPhones = () => {
  const [phones, setPhones] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [formData, setFormData] = useState(emptyForm);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);

  useEffect(() => {
    fetchPhones();
  }, []);

  const fetchPhones = async () => {
    setFetchLoading(true);
    try {
      const response = await axiosInstance.get("contact-phones/all");
      setPhones(response.data.data || []);
    } catch (error) {
      console.error("Error fetching contact phones:", error);
    }
    setFetchLoading(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    setButtonLoading(true);
    try {
      const payload = {
        office: formData.office,
        phone: formData.phone,
      };
      if (formData.order !== "" && formData.order !== null && formData.order !== undefined) {
        payload.order = Number(formData.order);
      }
      await axiosInstance.post("contact-phones/create", payload);
      await fetchPhones();
      setShowCreateModal(false);
      setFormData(emptyForm);
      Swal.fire("Success!", "Contact phone created successfully!", "success");
    } catch (error) {
      Swal.fire(
        "Error",
        error.response?.data?.message || "Failed to create contact phone",
        "error"
      );
    }
    setButtonLoading(false);
  };

  const handleEdit = async (e) => {
    e.preventDefault();
    setButtonLoading(true);
    try {
      await axiosInstance.post(`contact-phones/change/${editId}`, {
        office: formData.office,
        phone: formData.phone,
        order: Number(formData.order || 0),
        _method: "PUT",
      });
      await fetchPhones();
      setShowEditModal(false);
      setFormData(emptyForm);
      Swal.fire("Success!", "Contact phone updated successfully!", "success");
    } catch (error) {
      Swal.fire(
        "Error",
        error.response?.data?.message || "Failed to update contact phone",
        "error"
      );
    }
    setButtonLoading(false);
  };

  const handleView = async (id) => {
    try {
      setShowEditModal(true);
      setEditId(id);
      const response = await axiosInstance.get(`contact-phones/single/${id}`);
      const data = response?.data?.data;
      setFormData({
        office: data?.office || "",
        phone: data?.phone || "",
        order: data?.order ?? "",
      });
    } catch (error) {
      Swal.fire("Error", "Failed to load contact phone", "error");
    }
  };

  const handleDelete = async (id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
      });
      if (!result.isConfirmed) return;

      await axiosInstance.delete(`contact-phones/delete/${id}`);
      await fetchPhones();
      Swal.fire("Deleted!", "Contact phone deleted successfully", "success");
    } catch (error) {
      Swal.fire(
        "Error",
        error.response?.data?.message || "Failed to delete contact phone",
        "error"
      );
    }
  };

  const renderForm = (onSubmit, submitLabel) => (
    <form onSubmit={onSubmit}>
      <div style={{ marginBottom: "10px" }}>
        <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>
          Office
        </label>
        <input
          type="text"
          name="office"
          value={formData.office}
          onChange={handleChange}
          required
          placeholder="e.g. Vice Chancellor Office"
          style={{
            width: "100%",
            padding: "8px",
            fontSize: "14px",
            borderRadius: "4px",
            border: "1px solid #ccc",
          }}
        />
      </div>
      <div style={{ marginBottom: "10px" }}>
        <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>
          Phone
        </label>
        <input
          type="text"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          required
          placeholder="e.g. 044-2636060"
          style={{
            width: "100%",
            padding: "8px",
            fontSize: "14px",
            borderRadius: "4px",
            border: "1px solid #ccc",
          }}
        />
      </div>
      <div style={{ marginBottom: "10px" }}>
        <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>
          Order
        </label>
        <input
          type="number"
          name="order"
          min="0"
          value={formData.order}
          onChange={handleChange}
          placeholder="Lower numbers appear first"
          style={{
            width: "100%",
            padding: "8px",
            fontSize: "14px",
            borderRadius: "4px",
            border: "1px solid #ccc",
          }}
        />
      </div>
      <button
        type="submit"
        style={{
          padding: "10px 20px",
          backgroundColor: "#4CAF50",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          marginTop: "10px",
        }}
      >
        {buttonLoading ? <CircularProgress size={24} color="inherit" /> : submitLabel}
      </button>
    </form>
  );

  return (
    <div>
      <h2 style={{ marginTop: 0, marginBottom: 16 }}>Contact Phones</h2>
      <p style={{ marginTop: 0, marginBottom: 16, color: "#666" }}>
        These numbers appear on the public Contact page, ordered by the Order field.
      </p>
      <button
        onClick={() => {
          setFormData(emptyForm);
          setShowCreateModal(true);
        }}
        style={{
          padding: "10px 20px",
          backgroundColor: "#4CAF50",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
          marginBottom: "20px",
          cursor: "pointer",
        }}
      >
        Add Contact Phone
      </button>

      <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
        {fetchLoading ? (
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 9999,
            }}
          >
            <CircularProgress />
          </div>
        ) : phones.length === 0 ? (
          <p style={{ color: "#888" }}>No contact phones yet. Add one to show on the Contact page.</p>
        ) : (
          phones.map((item) => (
            <div
              key={item._id}
              style={{
                width: "280px",
                padding: "15px",
                borderRadius: "8px",
                backgroundColor: "#fff",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
              <h3 style={{ marginTop: 0 }}>{item.office}</h3>
              <p style={{ margin: "0 0 8px", fontSize: "15px", color: "#333" }}>
                {item.phone}
              </p>
              <p style={{ margin: "0 0 8px", fontSize: "13px", color: "#4a90e2" }}>
                Order: {item.order ?? 0}
              </p>
              <Actions
                courseId={item._id}
                onEdit={handleView}
                onDelete={handleDelete}
              />
            </div>
          ))
        )}
      </div>

      <Modal
        isOpen={showCreateModal}
        onRequestClose={() => setShowCreateModal(false)}
        style={customModalStyles}
        contentLabel="Create Contact Phone"
      >
        <h2>Add Contact Phone</h2>
        {renderForm(handleCreate, "Create")}
      </Modal>

      <Modal
        isOpen={showEditModal}
        onRequestClose={() => {
          setShowEditModal(false);
          setFormData(emptyForm);
        }}
        style={customModalStyles}
        contentLabel="Edit Contact Phone"
      >
        <h2>Edit Contact Phone</h2>
        {renderForm(handleEdit, "Update")}
      </Modal>
    </div>
  );
};

export default ContactPhones;
